import { cn } from "@/lib/utils";
import { cva, type VariantProps } from "class-variance-authority";

// ============================================
// 스타일 (CVA)
// ============================================

const dividerVariants = cva("shrink-0", {
  variants: {
    variant: {
      normal: "bg-line-normal",
      thick: "bg-line-alternative",
    },
    orientation: {
      horizontal: "w-full",
      vertical: "h-full",
    },
  },
  compoundVariants: [
    { variant: "normal", orientation: "horizontal", className: "h-px" },
    { variant: "normal", orientation: "vertical", className: "w-px" },
    { variant: "thick", orientation: "horizontal", className: "h-3" },
    { variant: "thick", orientation: "vertical", className: "w-3" },
  ],
  defaultVariants: {
    variant: "normal",
    orientation: "horizontal",
  },
});

// ============================================
// 타입 정의
// ============================================

interface DividerProps
  extends React.HTMLAttributes<HTMLDivElement>,
    Omit<VariantProps<typeof dividerVariants>, "orientation"> {
  /** true이면 세로 방향 */
  vertical?: boolean;
  className?: string;
}

// ============================================
// Divider 컴포넌트
// ============================================

export const Divider = ({
  variant = "normal",
  vertical = false,
  className,
  ...rest
}: DividerProps) => {
  const orientation = vertical ? "vertical" : "horizontal";

  return (
    <div
      role="separator"
      aria-orientation={orientation}
      className={cn(dividerVariants({ variant, orientation }), className)}
      {...rest}
    />
  );
};
